import namespace from "@rdfjs/namespace";
export const sdmx = namespace("http://purl.org/linked-data/sdmx#");
